(() => {
    'use strict';

    // ace.require("ace/config").set("workerPath", "/js/ace-builds/src-min-noconflict");
    // ace.require("ace/ext/language_tools");

    let app = angular.module('cpm', [
        'cpm.templates',
        'ngRoute',
        'ui.bootstrap',
        'ui.bootstrap.tpls',
        'ngAnimate',
        'ngMessages',
        'ui.ace',
        'ui-notification',
        'once',
        'ui.select',
        'ngSanitize'
    ]);

    app.config(['$routeProvider', '$locationProvider', '$compileProvider', ($routeProvider, $locationProvider, $compileProvider) => {

        $routeProvider
        
            .when('/login', {
                templateUrl: 'login.html',
                title: 'Login',
                controller: 'LoginCtrl'
            })

            .when('/loading', {
                templateUrl: 'loading.html',
                title: 'Loading...',
                controller: 'LoadingCtrl'
            })

            .otherwise({
                redirectTo: '/accounts'
            });

        $locationProvider.html5Mode(true);
        $compileProvider.debugInfoEnabled(false);

        app.compileProvider = $compileProvider;

    }]);


    app.run(['$rootScope', 'UserService', '$location', 'ApiService', 'EVENTS', 'CONTENT_TYPE', 'Notification', '$uibModal', '$interval', ($rootScope, UserService, $location, ApiService, EVENTS, CONTENT_TYPE, Notification, $uibModal, $interval) => {

        $rootScope.currentBuildVersion = null;
        $rootScope.showingAlerts = [];
        $rootScope.currentYear = moment().year();

        if (/(Edge|Trident)/.test(navigator.userAgent)) {
            // relegate IE / Edge users to second-class citizens.
            document.body.classList.add('no-animations');
        }

        $rootScope.$on('accessDenied', () => {
            UserService.logout();
            $rootScope.currentUser = null;
            $location.path('/login');
        });

        $rootScope.errorScope = $rootScope.$new();
        $rootScope.errorScope.showErrorModal = () => {
            let modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'components/error-details-modal.html',
                controller: 'ErrorDetailsModalCtrl',
                resolve: {
                    error: () => {
                        return $rootScope.errorScope.errorMessage;
                    }
                }
            });
        };

        let onCloseCallback = (e) => {
            let idx = $rootScope.showingAlerts.indexOf($(e).text());
            if(idx > -1) {
                $rootScope.showingAlerts.splice(idx,1);
            }

        }

        //Probably not the best place to have this but couldn't think of anywhere better
        $rootScope.$on(EVENTS.SHOW_NOTIFICATION, (event, data) => {
            if(!data.duration) { data.duration = 5000; }
            else if(data.duration === -1) { data.duration = null; }
            if(!data.positionY) {data.positionY = "bottom"; }
            if(!data.positionX) {data.positionX = "right"; }
            if($rootScope.showingAlerts.indexOf(data.message) == -1) {
                $rootScope.showingAlerts.push(data.message);
            }
            else if(typeof data.stackDuplicates == "undefined" || data.stackDuplicates == null || !data.stackDuplicates) {
                return;
            }
            if(!data.messageType || data.messageType === "success") {
                Notification.success({message: data.message, positionY: data.positionY, templateUrl: "components/custom-notification.html",  scope: $rootScope.errorScope, positionX: data.positionX, delay: data.duration, onClose:onCloseCallback });
            }
            else if(data.messageType === "error") {
                if(!!data.showDetailsOption) { data.showDetailsOption = true; }
                $rootScope.errorScope.errorMessage = data.errorMessage;
                $rootScope.showDetailsOption = data.showDetailsOption;
                Notification.error({message: data.message, templateUrl: "components/custom-notification.html", scope: $rootScope.errorScope, positionY: data.positionY, positionX: data.positionX, delay: data.duration, onClose:onCloseCallback });
            }
            else if(data.messageType === "warning") {
                Notification.warning({message: data.message, positionY: data.positionY, templateUrl: "components/custom-notification.html",  scope: $rootScope.errorScope, positionX: data.positionX, delay: data.duration, onClose:onCloseCallback });
            }
        });

        $rootScope.$on('$routeChangeStart', (event, next, current) => {

            let path = $location.path();

            if(!next.$$route) {
                // this is the first call, we don't have a route
                if($rootScope.currentUser) {
                    // we have a current user so go to /accounts
                    $location.url('/accounts');
                }
                else {
                    // no current user so redirect login if we can't get a current user
                    UserService.getCurrentUser().then(
                        () => { $location.url(path); },
                        () => { $location.url('/login?returnTo=' + encodeURIComponent(path)); }
                    );
                    $location.url('/loading?returnTo=' + encodeURIComponent(path));
                }
            }
            else {

                if(!$rootScope.currentUser && next.$$route.originalPath != "/login" && next.$$route.originalPath != "/loading") {

                    if(!!next.params && next.$$route.originalPath == "/asset-library") {
                        Object.keys(next.params).forEach((key, idx) =>{
                            path += (idx === 0 ? "?" : "&") + key + "=" + next.params[key];
                        });
                    }

                    // no current user so redirect login if we can't get a current user
                    UserService.getCurrentUser().then(
                        () => { $location.url(path)},
                        () => { $location.url('/login?returnTo=' + encodeURIComponent(path))}
                    );
                    $location.url('/loading?returnTo=' + encodeURIComponent(path));
                }

            }

            if (next.role != null) {

                $rootScope.$broadcast('setTitle', next.title);

                if (!$rootScope.currentUser || $rootScope.currentUser.securityRoles.indexOf(next.role) == -1) {
                    event.preventDefault();
                }

            }

        });

        if($("#xPQnQPIjCXv3").length == 0) {
            setTimeout(() => {
                $rootScope.$emit(EVENTS.SHOW_NOTIFICATION, {'message': "An ad-blocker seems to be enabled, this will cause issues with Reflow and should be disabled.", messageType: "error"});
            }, 1000);
        }

        if(VERSION > 0) {
            $interval( () => {
                UserService.getLatestBuildVersion(RELEASE)
                    .then((response) => {
                        let latestVersion = response.data;
                        if(latestVersion != VERSION) {
                            let data = {
                                duration: 5000,
                                message: "Reflow has been updated, please refresh your browser to receive these updates." ,
                                errorMessage: response.data,
                                messageType: "error",
                                stackDuplicates: false,
                                showDetailsOption: false};
                            $rootScope.$emit(EVENTS.SHOW_NOTIFICATION, data);
                        }
                    }, (response) => {
                        console.error(response);
                });
            }, 300000);
        }

    }]);

})();
